import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@webapp/assets/fireworks.gif'


const _withScopeId = n => (_pushScopeId("data-v-6c8fe1f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "ready"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "message" }, "Your online tree is ready!", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fireworks" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  key: 2,
  class: "progress-area"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "status" }, "Creating online tree...", -1))

import { computed, onMounted, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { usePageTitle } from '@webapp/util/AppUtil'
import { useSyncSessionStore } from './SyncSessionStore'
import { toSyncSource } from './SyncSessionModel'
import { useSyncStore } from '@webapp/rd/SyncStore'
import { useResearchDataNotifications } from '@webapp/rd/ResearchDataNotifications'
import { LoadMode } from '@webapp/util/AsyncData'
import { SyncState } from '@webapp/rd/ResearchDataModel'
import { DataGroup } from '@webapp/gp/GroupAdminModel'
import TaskPage from '@webapp/util/TaskPage.vue'
import ProgressBar from '@webapp/util/ProgressBar.vue'
import Modal from '@webapp/util/Modal.vue'
import SyncSourceHeader from './SyncSourceHeader.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SyncOperationPage',
  props: {
    sessionId: {}
  },
  emits: ['complete', 'failed'],
  setup(__props: any, { emit }) {

const props = __props;





const router = useRouter()
const syncSessionStore = useSyncSessionStore()
const syncStore = useSyncStore()
const notifications = useResearchDataNotifications()

// Captured once from the session's state -- it outlives the session, which is torn down on completion.
const syncIdRef = ref<string>()
const syncRef = computed(() => syncStore.getAsyncSync(syncIdRef.value, LoadMode.EnsureLoaded)?.data)
const sourceRef = computed(() => syncRef.value ? toSyncSource(syncRef.value) : undefined)
const stateRef = computed(() => syncRef.value?.state)
const isCompleteRef = computed(() => stateRef.value === SyncState.Completed)
const isFailedRef = computed(() =>
  stateRef.value === SyncState.Failed || stateRef.value === SyncState.Cancelled)

const completedRef = ref(0)
const totalRef = ref(1)

const failedModalRef = ref<InstanceType<typeof Modal>>()

usePageTitle('Upload my tree')

notifications.onSyncProgress(args => {
  if (args.syncID === syncIdRef.value) {
    completedRef.value = args.completed
    totalRef.value = args.total
  }
})

notifications.onSyncStateChanged(args => {
  if (args.itemId === syncIdRef.value) {
    syncStore.getAsyncSync(args.itemId, LoadMode.Reload)
  }
})

// A failure sends the user back to Options with an explanation, where they can adjust and retry.
watch(isFailedRef, (failed) => {
  if (failed) {
    failedModalRef.value?.open()
  }
})

watch(isCompleteRef, (complete) => {
  if (complete) {
    syncSessionStore.destroyCompletedSessionAsync(props.sessionId)
    emit('complete')
  }
})

onMounted(() => {
  syncIdRef.value = syncSessionStore.getState(props.sessionId)?.syncId
  if (syncIdRef.value) {
    syncStore.getAsyncSync(syncIdRef.value, LoadMode.Reload)
  }
})

function onExplore() {
  router.push('/home')
}

function onFailedDismissed() {
  emit('failed')
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(TaskPage, {
    "no-brand": "",
    "no-back": "",
    "no-action": !isCompleteRef.value,
    "can-continue": true,
    onAction: onExplore
  }, {
    title: _withCtx(() => [
      _createTextVNode("Upload my tree")
    ]),
    secondaryAction: _withCtx(() => [
      (syncRef.value?.viewGroupId)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: _unref(DataGroup).getResearchPageUrl(syncRef.value.viewGroupId),
            class: "btn btn-outline-primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Manage my tree ")
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true)
    ]),
    actionText: _withCtx(() => [
      _createTextVNode("Explore my tree")
    ]),
    default: _withCtx(() => [
      (sourceRef.value)
        ? (_openBlock(), _createBlock(SyncSourceHeader, {
            key: 0,
            source: sourceRef.value
          }, null, 8, ["source"]))
        : _createCommentVNode("", true),
      (isCompleteRef.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
        : (!isFailedRef.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(ProgressBar, {
                value: completedRef.value,
                max: totalRef.value,
                smooth: ""
              }, null, 8, ["value", "max"]),
              _hoisted_6
            ]))
          : _createCommentVNode("", true),
      _createVNode(Modal, {
        ref_key: "failedModalRef",
        ref: failedModalRef,
        info: "",
        onHidden: onFailedDismissed
      }, {
        title: _withCtx(() => [
          _createTextVNode("Something went wrong")
        ]),
        default: _withCtx(() => [
          _createTextVNode(" We couldn't create your online tree. Let's try again. ")
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }, 8, ["no-action"]))
}
}

})